module.exports = __webpack_public_path__ + "5b5e4572.png";